<template>
  <div v-if="obs" class="card border-0 shadow-sm mt-3">
    <h5 class="mt-2 mb-2 ms-2">
      Observaciones y Respuestas
    </h5>
<!--
    <div class="card-header bg-secondary text-white py-2">
      <span class="material-symbols-outlined" style="vertical-align: middle; font-size: 18px;">
        assignment
      </span>
      <strong class="ms-1 small">Observaciones de la planilla</strong>
    </div>
-->
    <div class="card-body py-2">
      <div class="row g-2 small">
        <!-- GD -->
        <template v-if="obs.obsCodificadaGD || obs.obsComplementariaGD">
          <div class="col-12">
            <span class="badge bg-primary me-1">GD</span>
            <span class="fw-bold text-muted">Codificada:</span>
            <span class="ms-1">{{ obs.obsCodificadaGD }}</span>
          </div>
          <div class="col-12" v-if="obs.obsComplementariaGD">
            <span class="badge bg-primary me-1 invisible">GD</span>
            <span class="fw-bold text-muted">Complementaria:</span>
            <span class="ms-1">{{ obs.obsComplementariaGD }}</span>
          </div>
        </template>
        <!-- AM -->
        <template v-if="obs.obsCodificadaAM || obs.obsComplementariaAM">
          <div class="col-12">
            <span class="badge bg-success me-1">AM</span>
            <span class="fw-bold text-muted">Codificada:</span>
            <span class="ms-1">{{ obs.obsCodificadaAM }}</span>
          </div>
          <div class="col-12" v-if="obs.obsComplementariaAM">
            <span class="badge bg-success me-1 invisible">AM</span>
            <span class="fw-bold text-muted">Complementaria:</span>
            <span class="ms-1">{{ obs.obsComplementariaAM }}</span>
          </div>
        </template>
        <!-- CT -->
        <template v-if="obs.obsCodificadaCT || obs.obsComplementariaCT">
          <div class="col-12">
            <span class="badge bg-warning text-dark me-1">CT</span>
            <span class="fw-bold text-muted">Codificada:</span>
            <span class="ms-1">{{ obs.obsCodificadaCT }}</span>
          </div>
          <div class="col-12" v-if="obs.obsComplementariaCT">
            <span class="badge bg-warning text-dark me-1 invisible">CT</span>
            <span class="fw-bold text-muted">Complementaria:</span>
            <span class="ms-1">{{ obs.obsComplementariaCT }}</span>
          </div>
        </template>
        <!-- Sin observaciones -->
        <div v-if="!tieneObs" class="col-12 text-muted fst-italic">
          Sin observaciones registradas
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
export default {
  name: "PlanillaObs",
  props: {
    idPlanilla: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      obs: null,
    };
  },
  computed: {
    tieneObs() {
      if (!this.obs) return false;
      return (
        this.obs.obsCodificadaGD || this.obs.obsComplementariaGD ||
        this.obs.obsCodificadaAM || this.obs.obsComplementariaAM ||
        this.obs.obsCodificadaCT || this.obs.obsComplementariaCT
      );
    },
  },
  watch: {
    idPlanilla(val) {
      if (val) this.cargar();
    },
  },
  mounted() {
    if (this.idPlanilla) this.cargar();
  },
  methods: {
    async cargar() {
      try {
        const response = await api.get(`/vwplanillas/${this.idPlanilla}`);
        this.obs = response.data;
      } catch (error) {
        console.error("Error al cargar observaciones de planilla:", error);
      }
    },
  },
};
</script>